import { PropsWithChildren, Ref, forwardRef } from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import './index.styles.css'
interface Props {
  height: number
  width: number
  transform: string
  showPointer?: boolean
  ref: Ref<SVGSVGElement>
}

const Frame = forwardRef<SVGSVGElement, PropsWithChildren<Props>>(function Frame(
  { children, height, width, transform, showPointer = false },
  ref
) {
  return (
    <Box className={showPointer ? 'Frame_frame' : undefined}>
      <div style={{ width: width, height: height }}>
        <svg ref={ref} width={width} height={height}>
          <g transform={transform}>{children}</g>
        </svg>
      </div>
    </Box>
  )
})

export default Frame
